<template>
    <div class="guide-container" ref="guide">

        <div class="bg" @click="closeEv"></div>

        <div class="guide-content">

            <div class="roll-content">

                <div class="step-box">
                    <p class="title" data-index="1">扫描下方二维码，前往个人中心页面</p>
                    <div class="image-list">
                        <img src="http://cdn1.mimoprint.com/c-website/image/front/guide/1.png">
                    </div>
                </div>
                <div class="step-box">
                    <p class="title" data-index="2">参考下方图示在<span class="w-highlight">订单详情页</span>找到对应作品的<span class="w-highlight">订单编号</span>并<span class="w-highlight">复制</span></p>
                    <div class="image-list">
                        <img src="http://cdn1.mimoprint.com/c-website/image/front/guide/2.jpg?v=1">
                    </div>
                </div>
                <div class="step-box">
                    <p class="title" data-index="3">
                        用电脑打开以下网址：<span @click="toDiyEv" class="w-highlight" v-text="url" style="    text-decoration: underline;cursor: pointer;"></span>
                        <!-- <span class="copy-btn" @click="copyUrl(url)">点击复制</span> -->
                        <br/>
                        输入<span class="w-highlight">订单编号</span>开始制作，你也可以根据自己的<span class="w-highlight">收货信息</span>进行制作</p>
                    <div class="image-list">
                        <img style="box-shadow: 0 0 4px 0px #9e9e9e;" src="http://cdn1.mimoprint.com/c-website/image/front/guide/3.png?v=1">
                    </div>
                </div>

            </div>

        </div>
        <div class="outside-content">
            <div class="close" @click="closeEv">
                <svg t="1617172673355" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4267" width="32" height="32"><path d="M511.98711 73.139605a438.834339 438.834339 0 0 1 310.84099 749.675329 438.834339 438.834339 0 1 1-621.68198-621.68198 436.091625 436.091625 0 0 1 310.84099-127.993349m0-73.139056a511.973396 511.973396 0 1 0 362.03833 149.935065A510.144919 510.144919 0 0 0 511.98711 0.000549z" p-id="4268" data-spm-anchor-id="a313x.7781069.0.i14" class="selected" fill="#ffffff"></path><path d="M318.016685 654.193814m18.100993-18.100993l299.959313-299.959313q18.100993-18.100993 36.201986 0l15.515137 15.515137q18.100993 18.100993 0 36.201986l-299.959313 299.959313q-18.100993 18.100993-36.201986 0l-15.515137-15.515137q-18.100993-18.100993 0-36.201986Z" p-id="4269" data-spm-anchor-id="a313x.7781069.0.i15" class="selected" fill="#ffffff"></path><path d="M318.016685 369.749638m18.100993-18.100993l15.515137-15.515137q18.100993-18.100993 36.201986 0l299.959313 299.959313q18.100993 18.100993 0 36.201986l-15.515137 15.515137q-18.100993 18.100993-36.201986 0l-299.959313-299.959313q-18.100993-18.100993 0-36.201986Z" p-id="4270" data-spm-anchor-id="a313x.7781069.0.i13" class="selected" fill="#ffffff"></path></svg>
            </div>
            <div class="not-prompt" @click="notPromptEv">不再提示</div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'guide',

    data() {
        return {
            url: 'https://diy.mimoprint.com'
        }
    },

    methods: {

        //关闭移除
        closeEv() {
            this.$refs["guide"] && document.body.removeChild(this.$refs["guide"])
        },

        copyUrl(url) {
            var domUrl = document.createElement("input");
            domUrl.value = url;
            domUrl.id = "creatDom";
            document.body.appendChild(domUrl);
            domUrl.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            let creatDom = document.getElementById("creatDom");
            creatDom.parentNode.removeChild(creatDom);
            alert("已复制好，可贴粘。");
        },

        toDiyEv(){
            window.open('https://diy.mimoprint.com')
        },

        notPromptEv(){
            this.closeEv()
            window.localStorage.setItem('not-prompt-make-guide', true)
        },
        
    },
    
}
</script>

<style lang="less" scoped>
.guide-container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 90;
    .bg{
        position: absolute;
        background: rgba(0,0,0,.6);
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .guide-content{
        background: #fff;

        width: 1070px;
        max-width: 90vw;

        border-radius: 6px;
        overflow: hidden;

        height: 80vh;
        overflow-y: auto;

        .roll-content{
            padding: 30px 0;
        }

        .step-box{
            margin-bottom: 30px;
            .title{
                position: relative;
                text-align: center;
                font-weight: bold;
                font-size: 16px;
                margin-top: 40px;
                line-height: 1.7;
                &::before{
                    content: attr(data-index);
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    font-size: 16px;
                    background: #813f44;
                    color: #fff;
                    text-align: center;
                    line-height: 30px;
                    border-radius: 50%;
                    left: 50%;
                    transform: translateY(-34px) translateX(-50%);
                }
            }
            .copy-btn{
                color: #2196f3;
                font-size: 14px;
                margin-left: 6px;
                text-decoration: underline;
                cursor: pointer;
            }
            .image-list{
                margin-top: 20px;
                text-align: center;
                img{
                    max-width: 98%;
                }
            }
        }
    }

    .outside-content{
        width: 1070px;
        max-width: 90vw;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(43vh);
        font-size: 0;
        .close{
            text-align: center;
            svg{
                cursor: pointer;
            }
        }
        .not-prompt{
            position: absolute;
            right: 0;
            top: 50%;
            cursor: pointer;
            color: #fff;
            text-decoration: underline;
            font-size: 16px;
            transform: translateY(-50%);
        }
    }
}
</style>